import script from "./app-legend.vue?vue&type=script&lang=js"
export * from "./app-legend.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__